import { Injectable } from '@angular/core';
import { Navigator, ViewMode, KeyBase, NavigatorHelperBase } from '@kpd/framework-ngx';
import { PermissionsetKey } from 'app/shared/models/keys/permissionset-key';

@Injectable()
export class PermissionsetsNavigatorHelper extends NavigatorHelperBase {
  constructor(navigator: Navigator) {
    super(navigator);
  }
  composeOverviewUrl(): string {
    return `permissionsets`;
  }
  composeDetailUrl(key: PermissionsetKey): string {
    if (key.isGlobalPermission) {
      return `permissionsets/details/application/${key.applicationId}/permissionset/global/${key.permissionSetId}`;
    }
    return `permissionsets/details/application/${key.applicationId}/permissionset/${key.permissionSetId}`;
  }

  composeCreateUrl(): string {
    return `permissionsets/details/application/0/permissionset/0`;
  }

  protected navigateToDetail(
    entityKey: KeyBase,
    editMode: boolean,
    overrideCurrentBrowserHistoryItem: boolean = false,
    replaceLastChildInBreadCrumb: boolean = false,
    params?: object,
  ): Promise<boolean> {
    let parameters = {};
    if (entityKey instanceof PermissionsetKey) {
      parameters = { ...params, copy: null };
    }
    return super.navigateToDetail(
      entityKey,
      editMode,
      overrideCurrentBrowserHistoryItem,
      replaceLastChildInBreadCrumb,
      parameters,
    );
  }

  navigateToCopy(key: string, isSingleMode: boolean): void {
    const params = {};
    params['copy'] = key;
    params['mode'] = ViewMode.Edit;

    const createRoute = [this.composeCreateUrl()];
    if (isSingleMode) {
      this.navigator.navigateChild(createRoute, { queryParams: params, queryParamsHandling: 'merge' });
      return;
    }
    this.navigator.navigateReplaceLastChild(createRoute, {
      queryParams: params,
      queryParamsHandling: 'merge',
    });
  }
}
